import { useConfig } from '../../../ConfigContext';
import { updateAt } from './helpers';

const MultipleZoomControl = () => {
  const {
    selectedMultipleZoomIndex,
    croppers,
    setCroppers,
    handleZoomPlus,
    handleZoomMinus,
  } = useConfig();
  const clearImage = () => {
    updateAt(setCroppers, selectedMultipleZoomIndex, { imageSrc: '' });
  };

  return (
    <div>
      {selectedMultipleZoomIndex != null && (
        <div>
          <button
            style={{
              background: '#c70034',
              float: 'left',
              marginTop: '10px',
              visibility:
                croppers[selectedMultipleZoomIndex].imageSrc !== ''
                  ? 'visible'
                  : 'hidden',
            }}
            onClick={() => clearImage()}
            className="submit-custom"
          >
            Smazat fotku
          </button>

          <div className="w-full flex items-center zooming">
            <label htmlFor="zoom" className="custom-label flex-1">
              Přiblížení fotografie:
            </label>
            <button
              onClick={() =>
                handleZoomMinus('multiple', selectedMultipleZoomIndex)
              }
            >
              -
            </button>
            <input
              id="zoom"
              type="range"
              min="1"
              max="10"
              step="0.01"
              value={croppers[selectedMultipleZoomIndex].zoom}
              onChange={(e) =>
                handleZoomPlus(
                  'multiple_full',
                  selectedMultipleZoomIndex,
                  parseFloat(e.target.value)
                )
              }
              className="w-full flex-1 w-[50%]"
              style={{
                background: '#874fb7',
                color: '#874fb7',
              }}
            />
            <button
              onClick={() =>
                handleZoomPlus('multiple', selectedMultipleZoomIndex)
              }
            >
              +
            </button>
            <div className="text-sm text-gray-500 mt-1 items-center flex-1">
              zoom:{' '}
              <span className="font-semibold">
                {croppers[selectedMultipleZoomIndex].zoom}×
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MultipleZoomControl;
